'use client';

import { createContext, useContext, useEffect, useState } from 'react';
import { noop } from 'lodash';
import type { Asset } from '@frameio/graphql-client/generated';

type VersionId = Asset['id'] | null;

export const SetActiveVersionIdContext =
  createContext<(versionId: VersionId) => void>(noop);
export const IsolatedActiveVersionIdContext = createContext<VersionId>(null);

export const useActiveVersionId = () =>
  useContext(IsolatedActiveVersionIdContext);
export const useSetActiveVersionId = () =>
  useContext(SetActiveVersionIdContext);

type IsolatedActiveVersionIdContextProviderProps = {
  children: React.ReactNode;
  versionId: VersionId | null;
};

export const IsolatedActiveVersionIdContextProvider = ({
  versionId: versionIdFromProps,
  children,
}: IsolatedActiveVersionIdContextProviderProps) => {
  const [versionId, setVersionId] = useState<VersionId>(versionIdFromProps);

  useEffect(() => setVersionId(versionIdFromProps), [versionIdFromProps]);

  return (
    <IsolatedActiveVersionIdContext.Provider value={versionId}>
      <SetActiveVersionIdContext.Provider value={setVersionId}>
        {children}
      </SetActiveVersionIdContext.Provider>
    </IsolatedActiveVersionIdContext.Provider>
  );
};
